import PopImage from '@components/PopImage'
import PopLink from '@components/PopLink'
import { convertNodeToElement } from 'react-html-parser'
import styled from 'styled-components'
import { ARTICLE_PREVIEW_NAME, ArticlePreviewIframe } from '../article-preview'
import { COMMODITY_LINK_NAME, CommodityLinkIframe } from '../commodity-link'
import ImageLinkCard, { IMAGE_LINK_CARD_NAME } from '../ImageLinkCard'
import { TABLE_OF_CONTENTS_NAME, TableOfContents } from '../table-of-content'
import InstagramEmbed from './InstagramEmbed'

const StylePopImage = styled(PopImage)`
  width: 100%;
  padding-top: ${(props) => props.ratio * 100}%;
`

const urlRegexDomainCheck = (regexStr, str) => new RegExp(`.${regexStr}.`, 'ig').test(str)

const transformFactory = (noShaper, isApp, clas, postID) => {
  const transform = (node, index) => {
    const { type, name, attribs, children = [] } = node
    if (type !== 'tag') return convertNodeToElement(node, index, transform)

    if (name === 'nothing') {
      return null
    }

    if (name === 'a') {
      return (
        <PopLink key={index} url={attribs.href}>
          {children.map(transform)}
        </PopLink>
      )
    }

    if (name === 'img') {
      const { alt = '', src, width, height } = attribs

      if (!src) return null
      const ratio =
        width && height ? Math.floor((parseInt(height) / parseInt(width)) * 100) / 100 : 1

      return (
        <StylePopImage
          showOriginal={noShaper}
          imageUrl={src}
          sizes={`(min-width: 1216px) 750px, (min-width: 992px) 620px, (min-width: 768px) 690px, calc(100vw - 30px)`}
          ratio={ratio}
          key={index}
          alt={alt}
        />
      )
    }

    // iframe 轉換
    // iframe 有可能在 p 底下
    // 只能用 span 包起來
    if (name === 'iframe') {
      const { src } = attribs
      const isYouTube = urlRegexDomainCheck('youtube', src)
      const isFacebook = urlRegexDomainCheck('facebook', src)
      const isSkyScanner = urlRegexDomainCheck('skyscanner', src)

      // YouTube iframe 轉換
      if (isYouTube) {
        return (
          <span key={index} className="ytIframeContent">
            <iframe
              src={src}
              frameBorder="0"
              scrolling="no"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </span>
        )
      }

      // Facebook iframe 轉換
      if (isFacebook) {
        const isConvertFromOldText = src.startsWith('https://www.facebook.com/plugins/video.php')
        const fbSrc = isConvertFromOldText
          ? src
          : `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(src)}`

        return (
          <span key={index} className="fbIframeContent">
            <iframe
              src={fbSrc}
              frameBorder="0"
              scrolling="no"
              allow="encrypted-media"
              allowFullScreen
            />
          </span>
        )
      }

      /**
       * SkyScanner iframe 轉換
       * 客戶有兩種高度 皆屬固定高度 透過url來判斷為佳
       *   302: https://widgets.skyscanner.net/widget-server/widgets/iframe?skyscannerWidget=InsiderTipsWidget&tipType=leadtime&associateId=API_B2B_19158_00001&locale=zh-TW&market=TW¤cy=TWD&originName='Taipei'&destinationName='Tokyo'&buttonColour=%23DC3A39&chartHighlightColour=%23DC3A39&textColour=%23DC3A39&chartColour=%23CECAD5&poweredByLogoColour=dark&target=_blank&customReferralParams=utm_term%3Dtypicalprice_tokyo_japan%2F453980
       *   203: https://widgets.skyscanner.net/widget-server/widgets/iframe?skyscannerWidget=InsiderTipsWidget&tipType=indicative_price&associateId=API_B2B_19158_00001&locale=zh-TW&market=TW%C2%A4cy=TWD&originName=%27Taipei%27&destinationName=%27Seoul%27&buttonColour=%23DC3A39&chartColour=%23CECAD5
       */
      if (isSkyScanner) {
        const style = { height: src.indexOf('indicative_price') !== -1 ? '203px' : '302px' }
        return <iframe key={index} src={src} style={style} />
      }
    }

    if (name === 'instagram') {
      const { url } = attribs

      return <InstagramEmbed key={index} url={url} />
    }

    if (name === IMAGE_LINK_CARD_NAME) {
      return <ImageLinkCard key={index} {...attribs} noShaper={noShaper} index={index} />
    }

    if (name === ARTICLE_PREVIEW_NAME) {
      return <ArticlePreviewIframe key={index} {...attribs} />
    }

    if (name === COMMODITY_LINK_NAME) {
      return <CommodityLinkIframe key={index} {...attribs} />
    }

    if (name === TABLE_OF_CONTENTS_NAME) {
      return <TableOfContents key={index} {...attribs} clas={clas} postID={postID} />
    }

    if (name === 'ad') {
      return null
    }

    return convertNodeToElement(node, index, transform)
  }

  return transform
}

export default transformFactory
